import type { Point } from 'highcharts';

type PointLabelOptions = {
  /** When true, zero values are shown (column chart). When false, they are skipped (line chart). */
  allowZeroValues?: boolean;
};

export function isPointLabelValue(point: Point, { allowZeroValues = false }: PointLabelOptions = {}): boolean {
  const pointWithNull = point as Point & { isNull?: boolean };

  if (pointWithNull.isNull) {
    return false;
  }

  if (point.options && 'y' in point.options && point.options.y == null) {
    return false;
  }

  const y = point.y;

  if (typeof y !== 'number' || Number.isNaN(y)) {
    return false;
  }

  return allowZeroValues || y !== 0;
}

export function getPointLabelValue(point: Point, options?: PointLabelOptions): number | null {
  if (!isPointLabelValue(point, options)) {
    return null;
  }

  return point.y as number;
}
